import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import PageSectionHeading from '../../PageSectionHeading';
import HomeCard from '../../HomeCard';
import { colors } from '../../../styles';

const styles = css`
  padding: 0;
  background-color: ${colors.neutral};
  position: relative;
  z-index: 2;
  @media(min-width: 992px) {
    padding: 120px 0;
  }
  .TabMenu {
    margin: 0 0 15px 0;
    text-align: center;
    @media (min-width: 992px) {
      margin: 30px 0 0 0;
    }
    .tab {
      opacity: .5;
      border-bottom: 0;
    }
  }
  .active {
    border-bottom: 4px solid ${colors.brand3}!important;
    opacity: 1!important;
  }
  .ContentWrapper {
    background-color: ${colors.brand6};
    background-image: url('/images/pattern-01-dark.svg');
    background-size: 110% auto;
    background-position: center center;
    padding: 160px 0 0 0;
    margin: -145px 0 0 0;
    @media (min-width: 992px) {
      padding: 170px 0 0 0;
      margin: -120px 0 0 0;
    }
  }
  .CardContainer {
    width: 100%;
    margin: 0 auto 15px auto;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
    clip-path: inset(0 0 30px 0); /* hide scroll bar on mobile */
  }
  .CardRow {
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    flex-wrap: nowrap;
    justify-content: center;
    padding: 0 30px;
    width: fit-content;
    min-width: 100vw;
    .HomeCard_featured {
      @media (pointer: fine) {
        @media(min-width: 900px) and (max-width: 1279px) {
          :nth-child(n+3) {
            display: none;
          }
        }
        @media(min-width: 1280px) and (max-width: 1699px) {
          :nth-child(n+4) {
            display: none;
          }
        }
        @media(min-width: 1700px) {
          :nth-child(n+5) {
            display: none;
          }
        }
      }
    }
  }
  .ButtonWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: -30px 0 0 0;
    @media (min-width: 992px) {
      margin: 0;
    }
    .btn {
      font-size: 14px;
      padding: 10px 15px;
      transform: translateY(50%);
      @media (min-width: 992px) {
        padding: 20px 30px;
        font-size: 16px;
      }
    }
  }
  .PageSection_header {
    margin-top: 45px;
    padding-bottom: 15px;
    @media (min-width: 992px) {
      margin-top: 0;
      padding-bottom: 30px;
      background-color: ${colors.neutral};
    }
  }
  .HomeCard_featured {
    width: calc(100vw - 110px);
  }
`;


class FeaturedProducts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: undefined,
    };
  }
  componentDidMount() {
    this.setUpTabs();
  }

  setUpTabs = () => {
    const defaultArea = this.props.areas.filter(area => area.parentMetro && !area.isMetro)[0];
    this.setState({
      tab: get(defaultArea, 'name'),
    });
  }

  switchTabHandler = tab => {
    this.setState({
      tab,
    });
  }

  render() {
    const { areas, content } = this.props;
    const { tab } = this.state;
    const selectedArea = areas.find(area => area.name === tab);
    const selectedHomes = get(selectedArea, 'homes', []).filter(home => home.status === 'Active' && home.price > 0);
    return (
      <div className={styles}>
        <PageSectionHeading h3={get(content, '[0].homes_heading')} />
        <div className="container-fluid">
          <div className="TabMenu">
            {
              areas.filter(area => area.parentMetro && !area.isMetro).map(submetro => (
                <button
                  onClick={() => this.switchTabHandler(submetro.name)}
                  tabIndex={0}
                  className={`tab ${tab === submetro.name ? 'active' : ''}`}
                  key={submetro._id}
                >
                  {submetro.name}
                </button>
            ))
            }
          </div>
        </div>
        <div className="ContentWrapper">
          {
            areas.length > 0 &&
            <div>
              <div className="CardContainer">
                {
                  selectedHomes.length > 0 &&
                  <div className="CardRow">
                    {
                      orderBy(selectedHomes, 'price', 'desc').map(home => (
                        <HomeCard
                          home={home}
                          key={home._id}
                          hideCommunity
                          hideFloorplan
                          hideLot
                          className="HomeCard_featured"
                        />
                      ))
                    }
                  </div>
                }
                {
                  selectedHomes.length === 0 &&
                  <p className="text-center">There are no quick move-in homes available in this area at this time.</p>
                }
              </div>
              <div className="ButtonWrapper">
                <Link name="homes" params={{ communityMarketAreaMetro: get(selectedArea, 'name') }} className="btn btn-white btn-arrow-black">View All {get(selectedArea, 'name')} Homes</Link>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}


FeaturedProducts.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
  areas: PropTypes.arrayOf(PropTypes.object).isRequired,
  // homes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

FeaturedProducts.defaultProps = {
};

export default withData({
  areas: 'all',
  homes: 'all',
})(FeaturedProducts);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/FeaturedProducts.section.js